<template>
    <v-container fluid class="dark-background primary">
        <copyright />
    </v-container>
</template>

<script>
    import Copyright from "./Copyright";

    export default {
        name: 'Footer',
        props: ['isCheckout'],
        components: {
            Copyright
        }
    }
</script>
